// extracted by mini-css-extract-plugin
module.exports = {"chatAssistant":"ChatbotWrapper_chatAssistant__hvDjI"};